import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from '+/instances/propTypesInstance';
import { path } from '+/utils/pathFinder';

export const SignOut = ({ signOutUser }) => {
  const [signedOut, setSignedOut] = useState(false);

  // Wait for the server-side sign-out to confirm before redirecting, so
  // the next page's useCurrentUser fetch doesn't race the in-flight DELETE
  // and rehydrate the user from the still-valid session cookie. On a
  // server-side failure signOutUser resolves false; we stay on this route
  // (rendering null) so the user isn't misled into thinking they're
  // signed out — the container has already surfaced the error via a toast.
  useEffect(() => {
    let cancelled = false;
    signOutUser().then(success => {
      if (!cancelled && success) setSignedOut(true);
    });
    return () => {
      cancelled = true;
    };
  }, [signOutUser]);

  if (!signedOut) return null;
  return <Redirect to={path('signIn')} />;
};

SignOut.propTypes = {
  signOutUser: PropTypes.func.isRequired,
};
